import Box from "@mui/material/Box";
import { wordmarkSx } from "@/theme/tokens";
import { brand } from "@/lib/brand";

/**
 * The brand wordmark: company name in the display serif followed by a small
 * violet terminal square — the one repeated brand gesture across the header,
 * inner-page top bar, footer, onboarding, and press kit. Callers set
 * `fontSize`; the terminal square scales with it (em units).
 */
export function Wordmark({ fontSize = "1.15rem" }: { fontSize?: string }) {
  return (
    <Box
      component="span"
      sx={{
        ...wordmarkSx,
        fontSize,
        whiteSpace: "nowrap",
        display: "inline-flex",
        alignItems: "baseline",
        gap: "0.18em",
      }}
    >
      {brand.name}
      <Box
        component="span"
        aria-hidden
        sx={{
          width: "0.16em",
          height: "0.16em",
          backgroundColor: "primary.main",
          flexShrink: 0,
        }}
      />
    </Box>
  );
}
